import styled, { css } from 'styled-components';
import { themeColor } from '../../../theme/getters';
import { modalHeading, smallParagraph, modalLink } from '../../../theme/typography';
import { Input as InputBase } from '../input';
import { Button, BUTTON_MODAL_TYPE } from '../button';

export const Title = styled.h1`
  ${modalHeading};
  margin-top: 8px;
  margin-bottom: 48px;
  color: ${themeColor('white')};
`;

export const Input = styled(InputBase).attrs({
  containerStyles: css`
    margin-bottom: 16px;
  `,
})`
  border-radius: 0;
`;

export const SubmitButton = styled(Button).attrs({
  theme: BUTTON_MODAL_TYPE,
})`
  box-shadow: none;
  margin-top: 16px;
`;

export const BottomText = styled.span`
  ${smallParagraph};
  color: ${themeColor('gray')};

  &:after {
    display: none;
  }
`;

export const Link = styled.a`
  ${modalLink};
  position: initial;
  color: ${themeColor('gray')};

  &:first-of-type {
    margin-right: 20px;
  }

  &:after {
    background: ${themeColor('gray')};
  }
`;

export const Form = styled.form`
  margin-bottom: 32px;
  width: 100%;
`;

export const Description = styled.p`
  ${smallParagraph};
  color: ${themeColor('white')}
  margin-bottom: 32px;
  width: 100%;
  text-align: center;
`;
